import gql from 'graphql-tag'

export const GET_PURCHASE_TRANSACTION_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!],
		$query: String
  ) {
    getPurchaseTransactionPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
				query: $query
      }
    ) {
      hasMore
      total
      items {
        id
				client {
					uid
					fullName
					telNumber
				}
				clientAnonymous {
					fullName
					telNumber
				}
				amount
				type
				currency {
					title
					symbol
					main
				}
				status
				paymentId
				externalId
				transactionDate
				createdAt
      }
    }
  }
`;

export const GET_PURCHASE_TRANSACTION_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getPurchaseTransaction (
      data: {
        id: $id
      }
    ) {
      id
			client {
				uid
				fullName
				telNumber
			}
			clientAnonymous {
				fullName
				telNumber
			}
			amount
			type
			currency {
				title
				symbol
				main
			}
			status
			paymentId
			externalId
			transactionDate
			createdAt
    }
  }
`;
